<template>
    <b-container>
        <b-card v-if="userName===null && userData.username===null">
            <h4> Create a new User </h4>
        </b-card>
        <b-card v-if="userName!==null || userData.username!==null">
            <h4> Change Your Credenetials</h4>
        </b-card>
        <b-card>
            <b-form @submit="onSubmit">
                <b-form-group
                    id="input-group-1"
                    label="Old Password:"
                    label-for="input-1"
                    description="Old Password">
                    <b-form-input
                        id="input-1"
                        v-model="userData.old_password"
                        type="password"
                        placeholder="password"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-2"
                    label="New Password:"
                    label-for="input-2"
                    description="New Password">
                    <b-form-input
                        id="input-2"
                        v-model="userData.new_password"
                        type="password"
                        placeholder="new password"
                    ></b-form-input>
                </b-form-group> 
                <b-button type="submit" variant="primary"> {{buttonText}}</b-button>
            </b-form>
        </b-card> 
    </b-container>
</template>
<script>
import {UserApi} from "@/api/userApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
export default {
    name: "UserCredentials",
    mixins: [userMixin],
    props: {
        userName: {
            type: String,
            required: false,
            default: 'me'
        },
        forceChangePassword: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            options: [],
            userData: {
                username: null,
                password: null,
                email: null,
                full_name: null,
                ward_id: null,
                stake_id: null,
                application_roles: [],
                disabled: false,
                old_password: null,
                new_password: null,
            }
        }
    },
    computed:{
        buttonText(){
            if(this.userName === 'me')
                return "Update"
            return "Create"
        },
        availableOptions() {
            return this.options.filter(opt=>this.userData.application_roles.indexOf(opt.value) === -1);
        }
    },
    async mounted() {
        this.options = this.$store.state.frontEndSettings.application_roles;
        await this.getUser();

    },
    methods: {
        async getMe() {
            const { data } = await UserApi.getUser();
            //console.log(data);
            this.userData = data;
        },
        async getUser() {
            const { data } = await UserApi.getUserDetail(this.userName);
            this.userData = data

        },        
        async onSubmit(event) {
            event.preventDefault();
            let data = {
                password: this.userData.old_password,
                new_password: this.userData.new_password       
            };
            try{
                if(this.userName === 'me')
                {
                    //console.log(data);
                    const {response} = await UserApi.updateUserCredentials(data);
                    this.getUserProfile();
                    this.$toast.success("Successfully Updated User");
                    //console.log(response);
                }else{
                    //console.log("Update Someone else");
                }
                this.$router.push({ name: 'user' });
            }catch(e) {
                handleError(e, "Could not update user");

            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>